import { useI18n } from 'vue-i18n';

export const usePortalEmptyStateContent = () => {
  const { t } = useI18n();

  return [
    {
      id: 1,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_1'),
      status: 'draft',
      updatedAt: 1729205669,
      author: { availableName: 'Michael' },
      category: {
        slug: 'configuration',
        icon: '📦',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_1'),
      },
      views: 3400,
    },
    {
      id: 2,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_2'),
      status: 'published',
      updatedAt: 1729205669,
      author: { availableName: 'John' },
      category: {
        slug: 'onboarding',
        icon: '🧑‍🍳',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_2'),
      },
      views: 400,
    },
    {
      id: 3,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_3'),
      status: 'archived',
      updatedAt: 1729205669,
      author: { availableName: 'Fernando' },
      category: {
        slug: 'best-practices',
        icon: '⛺️',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_3'),
      },
      views: 400,
    },
    {
      id: 4,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_4'),
      status: 'draft',
      updatedAt: 1729205669,
      author: { availableName: 'Jane' },
      category: {
        slug: 'design',
        icon: '🎨',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_4'),
      },
      views: 400,
    },
    {
      id: 5,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_5'),
      status: 'published',
      updatedAt: 1729205669,
      author: { availableName: 'Sarah' },
      category: {
        slug: 'integrations',
        icon: '🔗',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_5'),
      },
      views: 2800,
    },
    {
      id: 6,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_6'),
      status: 'draft',
      updatedAt: 1729205669,
      author: { availableName: 'Alex' },
      category: {
        slug: 'administration',
        icon: '🔐',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_6'),
      },
      views: 1200,
    },
    {
      id: 7,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_7'),
      status: 'published',
      updatedAt: 1729205669,
      author: { availableName: 'Emily' },
      category: {
        slug: 'content-management',
        icon: '📝',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_7'),
      },
      views: 5600,
    },
    {
      id: 8,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_8'),
      status: 'archived',
      updatedAt: 1729205669,
      author: { availableName: 'David' },
      category: {
        slug: 'features',
        icon: '🔍',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_8'),
      },
      views: 1800,
    },
    {
      id: 9,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_9'),
      status: 'published',
      updatedAt: 1729205669,
      author: { availableName: 'Rachel' },
      category: {
        slug: 'analytics',
        icon: '📊',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_9'),
      },
      views: 3200,
    },
    {
      id: 10,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_10'),
      status: 'draft',
      updatedAt: 1729205669,
      author: { availableName: 'Carlos' },
      category: {
        slug: 'localization',
        icon: '🌍',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_10'),
      },
      views: 900,
    },
    {
      id: 11,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_11'),
      status: 'published',
      updatedAt: 1729205669,
      author: { availableName: 'Olivia' },
      category: {
        slug: 'education',
        icon: '🎓',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_11'),
      },
      views: 4100,
    },
    {
      id: 12,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_12'),
      status: 'draft',
      updatedAt: 1729205669,
      author: { availableName: 'Nathan' },
      category: {
        slug: 'user-engagement',
        icon: '💬',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_12'),
      },
      views: 750,
    },
    {
      id: 13,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_13'),
      status: 'published',
      updatedAt: 1729205669,
      author: { availableName: 'Sophia' },
      category: {
        slug: 'seo',
        icon: '🚀',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_13'),
      },
      views: 2900,
    },
    {
      id: 14,
      title: t('HELP_CENTER.PORTAL_EMPTY_STATE.TITLE_14'),
      status: 'archived',
      updatedAt: 1729205669,
      author: { availableName: 'Daniel' },
      category: {
        slug: 'internal-resources',
        icon: '🏢',
        name: t('HELP_CENTER.PORTAL_EMPTY_STATE.NAME_14'),
      },
      views: 1500,
    },
  ];
};
